import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSearchParams } from 'react-router-dom';
import { Spinner } from 'ui';
import { useParseNumericQueryParam } from 'ui/hooks';

const TaskForceLogin = () => {
  const auth = useAuth();
  const [params] = useSearchParams();

  const businessId = useParseNumericQueryParam('business_id');
  const association = params.get('association');
  const appRole = params.get('app-role');
  const taskId = params.get('task_id');

  const redirect_uri = association
    ? `${window.location.origin}/public/tasks?business_id=${businessId}&association=${association}`
    : taskId
    ? `${window.location.origin}/tasks/${taskId}?business_id=${businessId}&app-role=${appRole}`
    : '';

  useEffect(() => {
    if (redirect_uri) {
      auth.signinRedirect({ redirect_uri });
    }
  }, [redirect_uri]);

  return (
    <div className="flex h-[100dvh] w-full items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
};

export default TaskForceLogin;
